module.exports = __webpack_public_path__ + "0aeb95ca37d0ef8dc1b26fc8506a90de.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-ski-s.png
// module id = 2369
// module chunks = 0